module.exports = __webpack_public_path__ + "static/media/icon_circle_minus.9fd7541b.svg";